class BAOProductDetails extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['tab', 'panel']
  }

  connectedCallback () {
    super.connectedCallback()

    this.moveReadMoreButtons()
  }

  setupListeners () {
    super.setupListeners()

    this.els.tab.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.onTabClick.bind(this))
    })

    if (this.els.readMore) {
      this.els.readMore.elements.forEach((button) => {
        this.listeners.add(button, 'click', this.onReadMoreClick.bind(this))
      })
    }
  }

  moveReadMoreButtons () {
    if (!this.els.readMore || !this.els.readMoreInitial) return

    this.els.readMore.elements.forEach((button, index) => {
      const initial = this.els.readMoreInitial.elements[index]

      if (!initial) return

      const children = initial.querySelectorAll(
        'p, li, h1, h2, h3, h4, h5, h6',
      )

      const target = children.length
        ? children[children.length - 1]
        : initial

      target.append(' ')
      target.append(button)
    })
  }

  onTabClick (event) {
    const activeTab = event.currentTarget
    const activeIndex = activeTab.dataset.productDetailsTab

    this.els.tab.elements.forEach((tab) => {
      const isActive = tab.dataset.productDetailsTab === activeIndex

      tab.classList.toggle('prd-ProductDetails_Tab-active', isActive)
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    this.els.panel.elements.forEach((panel) => {
      const isActive = panel.dataset.productDetailsPanel === activeIndex

      panel.classList.toggle('prd-ProductDetails_Panel-active', isActive)
      panel.hidden = !isActive
    })
  }

  onReadMoreClick (event) {
    const button = event.currentTarget
    const panel = button.closest('[data-product-details-panel]')

    if (!panel) return

    const content = panel.querySelector(
      '[data-bao-product-details-el="readMoreContent"]',
    )

    if (!content) return

    content.hidden = false
    button.remove()
  }
}

if (!customElements.get('bao-product-details')) {
  customElements.define('bao-product-details', BAOProductDetails)
}
